import React from "react";
import { sysAppExplorerStyles } from "./style.js";
import TrashBin from "../../systemApplications/TrashBin";
import AppViewer from "../../systemApplications/AppViewer";
import Clock from "../../systemApplications/Clock";
import Notes from "../../systemApplications/Notes";
import Setting from "../../systemApplications/Setting";

class SysAppExplorerGUI extends React.Component {
  render() {
    const scale = this.props.systemData.iconSize;
    return (
      <div
        style={{
          ...sysAppExplorerStyles.section,
          width:
            Math.floor(
              (this.props.dims.width * 0.9) / (100 * scale ? scale : 1)
            ) * (100 * scale ? scale : 1),
        }}
      >
        <div style={sysAppExplorerStyles.title}>{"Utilities"}</div>
        <div style={sysAppExplorerStyles.appBar}>
          <TrashBin
            fileSystem={this.props.fileSystem}
            systemData={this.props.systemData}
            scale={scale}
          />
          <AppViewer
            toggleAppExplorer={this.props.appFuncs.toggleAppExplorer}
            scale={scale}
          />
          <Notes
            systemData={this.props.systemData}
            updateSystemData={this.props.updateSystemData}
            scale={scale}
          />
          <Setting
            fileSystem={this.props.fileSystem}
            systemData={this.props.systemData}
            userInfo={this.props.userInfo}
            localMode={this.props.localMode}
            backgrounds={this.props.backgrounds}
            updateSystemData={this.props.updateSystemData}
            scale={scale}
          />
          <Clock
            systemData={this.props.systemData}
            updateSystemData={this.props.updateSystemData}
            scale={scale}
          />
        </div>
      </div>
    );
  }
}

export default SysAppExplorerGUI;
